import { URLS_CONFIG } from 'config';

export default ({
  token,
  campaignId,
  isDarkMode,
}) => `${URLS_CONFIG.public.leaderboard}?token=${token}&campaign=${campaignId}&darkmode=${isDarkMode}`;
